import { defineComponent as _defineComponent } from 'vue'
import { resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../images/icon/1.jpg'
import _imports_1 from '../../images/icon/2.jpg'


const _withScopeId = n => (_pushScopeId("data-v-2edca276"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "right" }
const _hoisted_2 = {
  key: 0,
  class: "loading",
  "element-loading-background": "rgba(255, 255, 255, 0.6)"
}
const _hoisted_3 = {
  class: "carousel",
  style: {"padding-right":"10px","padding-bottom":"52px"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"100%","height":"100%"},
  src: _imports_0,
  alt: "banner"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"100%","height":"100%"},
  src: _imports_1,
  alt: "banner"
}, null, -1))
const _hoisted_6 = { class: "top" }
const _hoisted_7 = { class: "search" }
const _hoisted_8 = { class: "content" }
const _hoisted_9 = { class: "father-item" }
const _hoisted_10 = { class: "title" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_12 = { class: "items" }
const _hoisted_13 = { class: "img" }
const _hoisted_14 = ["href"]
const _hoisted_15 = ["alt"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "icon" }

import { Search } from '@element-plus/icons-vue'
import { reactive, ref, watch } from 'vue';
import { usePinia } from '@/store';
import { storeToRefs } from 'pinia'
import { selectCagegoryInfo } from '@/api/contact'
import { useRoute, useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const route = useRoute()
const store = usePinia()
const { scrollY, menuName, shopList, showShop, showShopBt, detail } = storeToRefs(store) as any
showShopBt.value = true

//去往=详情
const toDetail = ele => {
  detail.value = ele
  router.push({
    name: 'similar-detail', query: {
      id: ele.id,
      category: ele.category,
      essentialDetailsKey: ele.essentialDetailsKey
    }
  })
}

const aHref = (v) => {
  return `/products/similar-detail.html?id=${v.id}&category=${v.category}&essentialDetailsKey=${v.essentialDetailsKey}`
}

//添加到购物车
const add = ele => {
  shopList.value.push(ele)
  showShop.value = true
}
//判断商品是否在购物车
const state = ele => {
  const active = shopList.value.find(v => v.id === ele.id)
  if (active) {
    return true
  } else {
    return false
  }
}

//轮询图片分割 
const splitImg = (imgs): any => {
  if (typeof imgs === 'string') {
    try {
      const list = imgs.split(',')
      return list[1]
    } catch (err) {
      console.log('分割图片出错了', err);
    }
  }

}

const params = reactive({ category: route.query.type, page: 1, size: 40, title: '' })
//商品分类列表
const list: any = ref({})
const total = ref(0)
const loading = ref(false)
const getList = async () => {
  loading.value = true
  const res = await selectCagegoryInfo(params) as any
  if (res) {
    list.value = res.data.data
    total.value = res.data.total
  } else {
    ElMessage.error(res.message)
  }
  loading.value = false
}
getList()

const currentChange = val => {
  params.page = val
  getList()
}
watch(menuName, (newVal, oldVal) => {
  // scrollY.value = window.scrollY
  params.category = newVal as any
  getList()
})


return (_ctx: any,_cache: any) => {
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_CirclePlus = _resolveComponent("CirclePlus")!
  const _component_CircleCheck = _resolveComponent("CircleCheck")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (loading.value)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, null, 512)), [
          [_directive_loading, loading.value]
        ])
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_carousel, { height: "311px" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_carousel_item, null, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }),
          _createVNode(_component_el_carousel_item, null, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_el_input, {
          modelValue: _unref(params).title,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(params).title) = $event)),
          placeholder: "What are you looking for…",
          class: "inputDeep",
          style: {"border":"none"}
        }, {
          append: _withCtx(() => [
            _createVNode(_component_el_button, { onClick: getList }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, { color: "#fff" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Search))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("p", null, _toDisplayString(_unref(route).query.type) + "（" + _toDisplayString(total.value) + "）", 1),
          _hoisted_11
        ]),
        _createElementVNode("div", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (ele) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "item",
              key: ele.id
            }, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("a", {
                  href: aHref(ele)
                }, [
                  _withDirectives(_createElementVNode("img", {
                    alt: ele.title
                  }, null, 8, _hoisted_15), [
                    [_directive_lazy, splitImg(ele.allImg)]
                  ])
                ], 8, _hoisted_14)
              ]),
              _createElementVNode("div", {
                class: "text",
                onClick: ($event: any) => (toDetail(ele))
              }, _toDisplayString(ele.title), 9, _hoisted_16),
              _createElementVNode("div", _hoisted_17, [
                (!state(ele))
                  ? (_openBlock(), _createBlock(_component_el_icon, {
                      key: 0,
                      size: 26,
                      color: "#ccc",
                      onClick: ($event: any) => (add(ele))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CirclePlus)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : (_openBlock(), _createBlock(_component_el_icon, {
                      key: 1,
                      size: 26,
                      color: "#FF771C"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CircleCheck)
                      ]),
                      _: 1
                    }))
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _createVNode(_component_el_pagination, {
      background: "",
      layout: "prev, pager, next",
      "page-size": 40,
      total: total.value,
      onCurrentChange: currentChange
    }, null, 8, ["total"])
  ]))
}
}

})